import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgBell = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.26 19.243c-.608-1.045-1.51-4.004-1.51-7.868a8.75 8.75 0 0 0-17.5 0c0 3.865-.903 6.823-1.51 7.868a1.75 1.75 0 0 0 1.51 2.632h4.464a4.375 4.375 0 0 0 8.572 0h4.464a1.75 1.75 0 0 0 1.51-2.632ZM14 23.625a2.625 2.625 0 0 1-2.474-1.75h4.948A2.625 2.625 0 0 1 14 23.625Zm-8.75-3.5C6.092 18.677 7 15.321 7 11.375a7 7 0 0 1 14 0c0 3.943.906 7.299 1.75 8.75H5.25Z" />
  </svg>
);
export default SvgBell;
